export const configEnv = {
    NFT1Address:'0xCA2A02899f83b12EB9c4a82b012C71e6728A81D4',
    NFT2Address:'0x781cA0B94Df6B2A76A21498b3194df5Fb513161F',
    SneakerNFTContractAddress:'0x620E71D1d7e984e45eed012c0b01e1779aFA24d0',
}